import React, { useState } from "react";
import { Flex } from "rebass";
import styled from "styled-components";
import { Body, Title1 } from "../../Text";
import { FloatingContainer, Modal } from "../../Wrappers";
import { ReactComponent as Increase } from "../../../Assets/Studio/increase.svg";
import { Button } from "../../Button";
import { getQueryParam } from "../../../Utilities/QueryParam";

export const Remix1080 = () => {
  const [isOpen, setModalOpen] = useState(getQueryParam("remix") === "true");
  return (
    <>
      <Modal
        isModalOpen={isOpen}
        setModalOpen={setModalOpen}
        handleModalClose={() => {
          setModalOpen(false);
        }}
        disableOutsideClose={false}
      >
        <FloatingContainer
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          alignContent="center"
          maxWidth="400px"
          py={3}
          px={3}
        >
          <MainFlex>
            <IncreaseIcon />
            <TitleText>1080p Remix</TitleText>
            <MainBody>
              Welcome to Studio, here you can remix your clip to add FX, Music,
              Meme’s and more. It’s also how we increase your clip from 720p to
              1080p.
            </MainBody>
            <Button
              flex={true}
              size="small"
              onClick={() => {
                setModalOpen(false);
              }}
            >
              Got it
            </Button>
          </MainFlex>
        </FloatingContainer>
      </Modal>
    </>
  );
};

const MainFlex = styled(Flex)`
  flex-direction: column;
  align-items: center;
  padding: 10px;
  gap: 15px;
`;

const TitleText = styled(Title1)``;

const MainBody = styled(Body)`
  text-align: center;
`;

const IncreaseIcon = styled(Increase)``;
